import axios from 'axios'

const dataCache = {}

export default {
    async resolveView(view) {
        if (typeof view === 'function') {
            return (await view()).default
        }

        return (await import(`../${view}.vue`)).default
    },

    async resolveData(dataUrl, data = {}, stepKey = null) {
        if (!dataUrl) {
            return { step: stepKey, ...data }
        }

        // Cache pro URL + Step
        // const cacheKey = `${dataUrl}:${stepKey ?? 'wizard'}`
        // if (dataCache[cacheKey]) {
        //     return { ...dataCache[cacheKey], ...data }
        // }

        const response = await axios.post(dataUrl, {
            step: stepKey,
            data
        })

        // todo was ist mit data, muss hier nicht auch rein?
        // dataCache[cacheKey] = { step: stepKey, ...response.data}

        return {
            step: stepKey,
            ...response.data,
            ...data,

        }
    }
}